import { FC } from 'react';
import Section from '~/components/core/section/section';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { BaseModuleProps } from './module-factory';
import SenderTypeCore from '~/components/sender-type/sender-type';
import { useTenant } from '@parcel2go/npm-p2g-app';
import { PublicSettings } from '~/lib/ui-serverless-settings';

const SenderTypeModule: FC<BaseModuleProps> = ({ errors, wrapper }) => {
  const { t } = useTranslation([TranslationNamespaces.CHECKOUT]);
  const { settings } = useTenant();

  if (settings[PublicSettings.ORDERPROCESS.SENDERTYPEENABLED] !== 'true') {
    return null;
  }

  return (
    <SenderTypeCore
      errors={errors}
      wrapper={(x) =>
        wrapper(
          <Section
            title={t('SENDER_TYPE_TITLE', { defaultValue: 'Reason for sending?' })}
            dataTestId="sender-type-section"
            loading={false}
          >
            {x}
          </Section>
        )
      }
    />
  );
};
export default SenderTypeModule;
